import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const basinApi = createApi({
    reducerPath: "boundary/basin",
    baseQuery: axiosBaseQuery,
    tagTypes: ["basinList"],
    endpoints: (builder) =>({
        basinFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['basinList'],
            query: (query = '') => ({
                url: "boundary/basin" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        // basinCreate: builder.mutation({
        //     invalidatesTags: ['basinList'],
        //     query: (data)=>({url: "boundary/basin/", method: "POST", data})
        // }),

        basinCreate: builder.mutation({
            invalidatesTags: ['basinList'],
            query: (data) => ({
                url: `boundary/basin/`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        basinUpdate: builder.mutation({
            invalidatesTags: ['basinList'],
            query: (data) => ({
                url: `/boundary/basin/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
        }),
        
        basinDelete: builder.mutation({
            invalidatesTags: ['basinList'],
            query: (id)=>({url: "/boundary/basin/"+id, method: "DELETE"})
        }),
        basinFindOne:builder.query<{ data: {}}, any | void>({
            query: (id:any) => ({
                url: "boundary/basin/" + id,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                };
            },
        }),
    })
})

export const { useBasinFindAllQuery, useBasinCreateMutation, useBasinUpdateMutation, useBasinDeleteMutation, useBasinFindOneQuery } = basinApi;
export {basinApi};
